import { useState } from "react";

interface CopyButtonProps {
  text: string;
}

export const CopyButton = ({ text }: CopyButtonProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      className="link small"
      onClick={handleCopy}
      type="button"
      style={{ marginLeft: '8px', fontSize: '10px' }}
    >
      {copied ? "COPIED!" : "COPY"}
    </button>
  );
};
